module.exports = __webpack_public_path__ + "static/media/rewards_basic.eb4638c8.png";